import React from 'react';
import styles from './Home.module.css';
import useScrollReveal from './hooks/useScrollReveal';
import Header from './Sections/Header';
import StatStrip from './Sections/StatStrip';
import HowItWorks from './Sections/HowItWorks';
import PaymentMethods from './Sections/PaymentMethods';
import FeatureBlocks from './Sections/FeatureBlocks';
import WalletBanner from './Sections/WalletBanner';
import PricingCTA from './Sections/PricingCTA';
import Faq from './Sections/Faq';
import CallToAction from './Sections/CallToAction';

const Home = () => {
  useScrollReveal(`[data-sr]`);

  return (
    <div className={styles.homePage}>
      <Header />
      <StatStrip />
      <HowItWorks />
      <PaymentMethods />
      <FeatureBlocks />
      <WalletBanner />
      <PricingCTA />
      <Faq />
      <CallToAction />
    </div>
  );
};

export default Home;
